import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { ResponseError } from '../../errors/ResponseError';
import { IDefaultSuccessResponseSchema } from '../../repositories/favorites/entities/delete_user_favorites/DefaultSuccessResponseSchema';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/delete_user_favorites/DeleteOfferFromFavoritesRequestSchema';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesResponse,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';

interface IDeleteNewbuildingFromFavoritesProps {
  httpApi: IHttpApi;
  logger: ILogger;
  newbuildingId: number;
}

export const deleteNewbuildingFromFavorites = async ({
  httpApi,
  logger,
  newbuildingId,
}: IDeleteNewbuildingFromFavoritesProps): Promise<IDefaultSuccessResponseSchema> => {
  try {
    const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters: {
        entityId: newbuildingId,
        dealType: EDealType.Sale,
        entityType: EEntityType.Newbuilding,
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'favorites#deleteNewbuildingFromFavorites',
        message: response.response.message as string,
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: response.response.errors as any,
        },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error, {
      domain: 'deleteNewbuildingFromFavorites',
    });

    throw error;
  }
};
